import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import { queryPayRoll } from '@api';

const FormItem = Form.Item;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageNo: 1,
    };
  }

  componentDidMount() {
    this.loadData(1);
  }

  loadData = (pageNo, condition) => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    this.setState({
      pageNo,
    });
    queryPayRoll(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
          currentTotal: res.data.currentTotal,
        });
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.loadData(1, values.condition);
      }
    });
  };

  handleFormReset = e => {
    e.preventDefault();
    this.props.form.resetFields();
    this.loadData(1);
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form
        layout="inline"
        onSubmit={this.handleSubmit}
        // style={{ textAlign: "right" }}
      >
        <FormItem label="搜索条件">
          {getFieldDecorator('condition')(<Input placeholder="请输入" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit">
            查询
          </Button>
          <Button style={{ marginLeft: 8, marginRight: '-16px' }} onClick={this.handleFormReset}>
            重置
          </Button>
        </FormItem>
      </Form>
    );
  };

  columns = () => {
    return [
      {
        title: '发生时间',
        dataIndex: 'cdate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD HH:mm') : ''}</span>;
        },
      },
      {
        title: '应用',
        dataIndex: 'price',
      },
      {
        title: '标题',
        dataIndex: 'title',
        render: (text, record) => {
          if (text.indexOf('年终奖') === -1) {
            return <Link to={`/home/wage/detail/${record.itemUuid}`}>{text}</Link>;
          }
          return <Link to={`/home/wage/detailBonus/${record.itemUuid}`}>{text}</Link>;
        },
      },
    ];
  };

  render() {
    const { data, total } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList" style={{ marginBottom: '16px' }}>
          <Row>
            <Col span={13} />
            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
        </div>
        <Table
          rowKey="uuid"
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
          size="small"
        />
      </Card>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/home/wage/Index.js